import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  link: {
    textDecoration: 'none !important',
  },
}));
